import React from 'react';

const Scrollbar = ({ children }) => {
	return (
		<div className="rde-scrollbar">
			{children}
		</div>
	);
};

export default Scrollbar;
